import { render, staticRenderFns } from "./byPassword.vue?vue&type=template&id=36fb394a&scoped=true"
import script from "./byPassword.vue?vue&type=script&lang=js"
export * from "./byPassword.vue?vue&type=script&lang=js"
import style0 from "./byPassword.vue?vue&type=style&index=0&id=36fb394a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb394a",
  null
  
)

export default component.exports